// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum ElevatorTraffic {
  P = 0,
  CarCall = 1,
  RearCarCall = 2,
  HallCall = 3,
  UpHallCall = 4,
  UpRearHallCall = 5,
  DownHallCall = 6,
  DownRearHallCall = 7,
  CarCallAnswered = 8,
  RearCarCallAnswered = 9,
  HallCallAnswered = 10,
  UpHallCallAnswered = 11,
  UpRearHallCallAnswered = 12,
  DownHallCallAnswered = 13,
  DownRearHallCallAnswered = 14
}
